import { ContactParams } from 'app/models/contact-params'
import { getContacts, getContactsLoader } from 'app/state/ducks/contacts/selectors'
import { loadContacts } from 'app/state/ducks/contacts/thunks'
import cleanUUID from 'app/views/components/functions/cleanUUID'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ContactsModal } from '../entity-contacts/contacts-modal'
import MainTable from 'app/views/components/Table/MainTable'
import { contactCols } from '../entity-contacts/contacts-columnDefs'
import {
  GridSortingStorage,
  GridPaginationStorage,
  GridColumnVisibilityStorage,
  useGridSorting,
  useGridPagination,
  useGridColumnVisibility,
} from 'app/utils/grid-sorting-storage'

interface Props {
  entityId?: string
}

export default function ManageEntityContacts({ entityId }: Props) {
  // Grid preferences hooks
  const { sorting, handleSortingChange } = useGridSorting(GridSortingStorage.entityContacts)
  const { pagination, handlePaginationChange } = useGridPagination(GridPaginationStorage.entityContacts)
  const { columnVisibility, handleColumnVisibilityChange } = useGridColumnVisibility(GridColumnVisibilityStorage.entityContacts)

  const dispatch = useDispatch()
  const contacts: ContactParams[] = useSelector(getContacts)
  const contactsLoader = useSelector(getContactsLoader)
  const [globalLoading, setGlobalLoading] = useState(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [contact, setContact] = useState<undefined | ContactParams>(undefined)

  useEffect(() => {
    setGlobalLoading(contactsLoader)
  }, [contactsLoader])

  useEffect(() => {
    dispatch(loadContacts())
  }, [])

  return (
    <>
      {contacts ? (
        <MainTable
          tableName='Contacts Table'
          isLoading={globalLoading}
          enableTopToolbar={false}
          csvExportEnabled={true}
          headerBackgroundColor='#F0EEEE'
          data={contacts.filter(
            p => cleanUUID(p?.entity?.id) === entityId
          ) ?? []}
          columnDefs={contactCols}
          initialSorting={[{ id: sorting.sortBy, desc: sorting.order === 'desc' }]}
          onSortingChange={handleSortingChange}
          initialPagination={pagination}
          onPaginationChange={handlePaginationChange}
          initialColumnVisibility={columnVisibility}
          onColumnVisibilityChange={handleColumnVisibilityChange}
          setRow={(e: ContactParams, cellName: string) => {
            if (cellName != 'id') {
              setContact(e)
              setEdit(true)
            }
          }}
          border
          controlSectionBorder={false}
        />
      ) : null}
      <ContactsModal open={edit} setOpen={setEdit} contact={contact} entityId={entityId} />
    </>
  )
}